import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer'
import moment from 'moment'

import latoBold from '../../../fonts/Lato-Bold.ttf'
import ladoRegular from '../../../fonts/Lato-Regular.ttf'

Font.register({
    family: 'Lato',
    fonts: [
        {
            src: ladoRegular
        },
        {
            src: latoBold,
            fontWeight: 'bold'
        }
    ]
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Lato',
        backgroundColor: 'white',
        fontSize: 10,
        padding: 20,
        // marginTop: -20
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        marginTop: '10px'
    },
    infoCliente: {
        marginTop: 10
    },
    dato: {
        marginTop: 5,
        display: 'flex',
        flexDirection: 'row'
    },
    dato2: {
        marginTop: 8,
        display: 'flex',
        flexDirection: 'row'
    },
    datoObs: {
        marginTop: 0
    },
    referencia: {
        marginTop: 15,
        color: '#483B4C',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 9
    },
    table: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: 2,
        paddingTop: 2,
        paddingBottom: 2,
        // borderBottomColor: '#8E24AA',
        fontWeight: '400',
        color: '#483B4C'
    },
    title: {
        marginTop: 5,
        padding: 2,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#FAF9FA',
        color: '#78667E',
        fontStyle: 'normal',
        fontSize: 9,
        fontWeight: '600',
        textTransform: 'uppercase'
    },
    item: {
        padding: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: '#78667E',
        fontStyle: 'normal',
        fontSize: 9,
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    itemDesLarga: {
        marginLeft: 10,
        marginBottom: 10,
        paddingLeft: 10,
        color: '#938a96',
        fontStyle: 'normal',
        fontSize: 9,
        fontWeight: '400'
    },
    itemFechas: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginLeft: 10,
        marginBottom: 10,
        paddingLeft: 10,
        color: '#938a96',
        fontStyle: 'normal',
        fontSize: 9,
        fontWeight: '400'
    },
    pptoTitle: {
        color: '#8E24AA',
        fontFamily: 'Lato',
        fontSize: 12,
        textTransform: 'uppercase'
    },
    labelNameFecha: {
        color: '#483B4C',
        marginTop: 5
    },
    labelNameNro: {
        color: '#483B4C',
        fontSize: 11,
        marginTop: '5px',
        fontWeight: '600'
    },
    labelName: {
        color: '#483B4C',
        width: 80,
    },
    labelName2: {
        color: '#483B4C',
        width: 100,
    },
    labelName2Obs: {
        color: '#483B4C',
        width: 80,
    },
    labelValue: {
        color: '#78667E',
        fontSize: 9,
        textTransform: 'uppercase'
    },
    labelValueObs: {
        color: '#78667E',
        fontSize: 11,
        marginTop: 10,
        marginLeft: 10,
    },
    wrapTotales: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    totales: {
        marginTop: 10,
        padding: 5,
        borderRadius: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        backgroundColor: '#FAF9FA',
        fontStyle: 'normal',
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    labelNameTotal: {
        color: '#483B4C',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9
    },
    labelValueTotal: {
        color: '#483B4C',
        fontWeight: 400,
        width: 110,
        fontSize: 10,
        textAlign: 'right'
    },
    labelNameIGV: {
        color: '#78667E',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9,
        textTransform: 'none'
    },
    containerLogo: {
        position: 'absolute',
        top: '40px',
        right: '50px',
        padding: '5px',
        boxSizing: 'border-box',
        width: '110px',
        height: '110px'
    },
    imgLogo: {
        objectFit: 'contain',
        width: '100%',
        height: '100%'
    },
    firmas: {
        margin: '85px 10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontWeight: '400',
        color: '#483B4C'
    },
    firmantes: {
        paddingTop: '5px',
        width: '30%',
        borderTop: '1px solid rgb(30, 29, 29);',
        textAlign: 'center',
        fontSize: '11px'
    }
})

const formatNumber = (value = 0, currency = null) => {

    let country = {
        iso: 'en-US',
        currency: 'USD',
        decimales: 0
    }

    if (currency === 'S/') {
        country.iso = 'es-PE'
        country.currency = 'PEN'
        country.decimales = 2
    }

    const formatter = new Intl.NumberFormat(country.iso, {
        style: 'currency',
        currency: country.currency,
        maximumFractionDigits: country.decimales,
        minimumFractionDigits: country.decimales
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    })

    return formatter.format(value)

}

export const PdfFileNP = ({ auth, infoEmp, dataPreview, viewOptions, urlLogo, nombre_columna_dias, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                <View style={styles.header}>
                    <View>
                        {pdf_color_formato ?
                            <Text style={{
                                color: pdf_color_formato,
                                fontFamily: 'Lato',
                                fontSize: 12,
                                textTransform: 'uppercase',
                                fontWeight: 'Bold'
                            }}>
                                NOTA DE PEDIDO
                            </Text>
                            :
                            <Text style={styles.pptoTitle}>
                                NOTA DE PEDIDO
                            </Text>
                        }
                        <Text style={styles.labelNameNro}>{`#0000${dataPreview.numero}`}</Text>
                        <Text style={styles.labelNameFecha}>{moment(new Date()).format('DD MMMM YYYY')}</Text>
                    </View>
                </View>

                <View style={styles.containerLogo}>
                    <Image
                        style={styles.imgLogo}
                        src={urlLogo}
                        alt="logo"
                    />
                </View>

                <InfoCliente
                    auth={auth}
                    info={dataPreview}
                />

                <View style={styles.referencia}>
                    <Text style={{ textTransform: 'uppercase' }}>{dataPreview.referencia}</Text>
                </View>

                <Items
                    info={dataPreview}
                    viewOptions={viewOptions}
                    nombre_columna_dias={nombre_columna_dias}
                    infoGeneral={infoGeneral}
                />

                <Totales
                    info={dataPreview}
                    viewOptions={viewOptions}
                />

                <Condiciones
                    info={dataPreview}
                    infoGeneral={infoGeneral}
                />

                <Firmas
                    info={dataPreview}
                    infoGeneral={infoGeneral}
                />

            </Page>
        </Document >
    )
}

const Items = ({ info, viewOptions, nombre_columna_dias, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral
    const { nombre_columna_dias: columnName } = info

    return (
        <>

            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA' }]}>
                <Text style={{ width: 200, textAlign: 'left' }}>Ítems</Text>
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'center' }}>Cant.</Text>
                }
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'center', textTransform: 'capitalize' }}>{columnName || 'Días'}</Text>
                }
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item && !viewOptions.ver_solo_titulos) &&
                    <Text style={{ width: 100, textAlign: 'center' }}>Unid</Text>
                }
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'right' }}>P. Unitario</Text>
                }
                {!viewOptions.ocultar_montos_items &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Subtotal</Text>
                }
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Dscto.</Text>
                }
                {!viewOptions.ocultar_montos_items &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Total</Text>
                }
            </View >

            {info?.items?.map((title, index) => {
                return (
                    <>
                        <View style={styles.title}>
                            <Text style={{ width: 200, textAlign: 'left' }}>{title.nombre}</Text>
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                // <Text style={{ width: 100, textAlign: 'center' }}>{title.cant}</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}></Text>
                            }
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                // <Text style={{ width: 100, textAlign: 'center' }}>{title.dias}</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}></Text>
                            }
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item && !viewOptions.ver_solo_titulos) &&
                                <Text style={{ width: 100, textAlign: 'center' }}></Text>
                            }
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                <Text style={{ width: 100, textAlign: 'right' }}>
                                    {formatNumber(title.precio_unitario, info.simbolo)}
                                </Text>
                            }
                            {!viewOptions.ocultar_montos_items &&
                                <Text style={{ width: 100, textAlign: 'right' }}>
                                    {formatNumber(title.pre_subtotal_precio, info.simbolo)}
                                </Text>
                            }
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                <Text style={{ width: 100, textAlign: 'right' }}>
                                    {formatNumber(title.descuento, info.simbolo)}
                                </Text>
                            }
                            {!viewOptions.ocultar_montos_items &&
                                <Text style={{ width: 100, textAlign: 'right' }}>
                                    {formatNumber(title.precio_subtotal, info.simbolo)}
                                </Text>
                            }
                        </View>
                        {!viewOptions.ver_solo_titulos && title.items?.map((item, index2) => (
                            <>
                                <View style={styles.item}>
                                    <Text style={{ width: 200, textAlign: 'left' }}>
                                        <Text style={{ marginLeft: 50 }}>{"  "}{index2 + 1}.</Text>
                                        <Text style={{ marginLeft: 100 }}>{"  "}{item.nombre}</Text>
                                    </Text>
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                        <Text style={{ width: 100, textAlign: 'center' }}>{item.cant}</Text>
                                    }
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                        <Text style={{ width: 100, textAlign: 'center' }}>{item.dias}</Text>
                                    }
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item && !viewOptions.ver_solo_titulos) &&
                                        <Text style={{ width: 100, textAlign: 'center' }}>{item.unidad_medida}</Text>
                                    }
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                        <Text style={{ width: 100, textAlign: 'right' }}>
                                            {formatNumber(item.precio_unitario, info.simbolo)}
                                        </Text>
                                    }
                                    {!viewOptions.ocultar_montos_items &&
                                        <Text style={{ width: 100, textAlign: 'right' }}>
                                            {formatNumber(item.pre_subtotal_precio, info.simbolo)}
                                        </Text>
                                    }
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                        <Text style={{ width: 100, textAlign: 'right' }}>
                                            {formatNumber(item.descuento, info.simbolo)}
                                        </Text>
                                    }
                                    {!viewOptions.ocultar_montos_items &&
                                        <Text style={{ width: 100, textAlign: 'right' }}>
                                            {formatNumber(item.precio_subtotal, info.simbolo)}
                                        </Text>
                                    }
                                </View>
                                {(item.descripcion_larga && item.descripcion_larga !== '') &&
                                    <View style={styles.itemDesLarga}>
                                        <Text>{item.descripcion_larga}</Text>
                                    </View>
                                }
                                {(item.fecha_inicio) &&
                                    <View style={styles.itemFechas}>
                                        <Text>F. Inicio: {moment(item.fecha_inicio).format('DD-MM-YYYY')}</Text>
                                        <Text style={{ marginLeft: '10px' }}>F. Término: {moment(item.fecha_fin).format('DD-MM-YYYY')}</Text>
                                    </View>
                                }
                            </>
                        ))}
                    </>
                )
            })}

        </>
    )
}

const InfoCliente = ({ auth, info }) => {

    return (
        <>
            <View style={styles.infoCliente}>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Cliente :</Text>
                    <Text style={styles.labelValue}>{info?.cliente || '--'}</Text>
                </View>
                {info?.razon_social &&
                    <View style={styles.dato}>
                        <Text style={styles.labelName}>Razón social :</Text>
                        <Text style={styles.labelValue}>{info?.razon_social || '--'}</Text>
                    </View>
                }
                {info?.direccion &&
                    <View style={styles.dato}>
                        <Text style={styles.labelName}>Dirección :</Text>
                        <Text style={styles.labelValue}>{info?.direccion || '--'}</Text>
                    </View>
                }
                <View style={[styles.dato, { marginTop: '15px' }]}>
                    <Text style={styles.labelName}>Contacto cliente :</Text>
                    <Text style={styles.labelValue}>{info?.contacto_nombre || '--'}</Text>
                </View>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Email contacto :</Text>
                    <Text style={styles.labelValue}>{info?.contacto_email || '--'}</Text>
                </View>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Ejecutivo :</Text>
                    <Text style={styles.labelValue}>{info?.nombre_ejecutivo_completo}</Text>
                </View>
            </View>
        </>
    )
}

const Totales = ({ info, viewOptions }) => {
    return (
        <View style={styles.wrapTotales}>
            <View style={{ width: '58%' }}></View>
            <View style={[styles.totales, { width: '42%' }]}>

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>SUBTOTAL</Text>
                        <Text style={styles.labelValueTotal}>
                            {info.simbolo}{' '}{info.sub_total}
                        </Text>
                    </View>
                }

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>( {info.descuento_porcentaje}% )  DESC</Text>
                        <Text style={styles.labelValueTotal}>
                            {info.simbolo}{' '}{info.descuento}
                        </Text>
                    </View>
                }

                <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal}>{viewOptions.ocultar_texto_igv ? 'TOTAL' : 'TOTAL NETO'}</Text>
                    <Text style={styles.labelValueTotal}>
                        {formatNumber(info.total_cliente, info.simbolo)}
                    </Text>
                </View>

                {/* <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal}>TOTAL</Text>
                    <Text style={styles.labelValueTotal}>
                        {formatNumber(info.total_cliente, info.simbolo)}
                    </Text>
                </View> */}

                {viewOptions.ver_total_con_impuestos &&
                    <>
                        <View style={styles.dato2}>
                            <Text style={styles.labelNameTotal}>( {info.porcentaje_impuesto}% )  IGV</Text>
                            <Text style={styles.labelValueTotal}>
                                {formatNumber(info.total_impuesto, info.simbolo)}
                            </Text>
                        </View>
                        <View style={styles.dato2}>
                            <Text style={styles.labelNameTotal}>TOTAL</Text>
                            <Text style={styles.labelValueTotal}>
                                {formatNumber(info.total, info.simbolo)}
                            </Text>
                        </View>
                    </>
                }

                {(!viewOptions.ver_total_con_impuestos && !viewOptions.ocultar_texto_igv) &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameIGV}>No incluye IGV</Text>
                    </View>
                }

            </View>
        </View>
    )
}

const Condiciones = ({ info, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <>
            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA', marginBottom: 0 }]}>
                <Text>CONDICIONES</Text>
            </View>

            <View style={styles.dato}>
                <Text style={styles.labelName2}>Moneda:</Text>
                <Text style={styles.labelValue}>
                    {info.moneda || '--'}
                </Text>
            </View>

            <View style={styles.dato}>
                <Text style={styles.labelName2}>Forma de pago:</Text>
                <Text style={styles.labelValue}>{info.forma_pago || '--'}</Text>
            </View>

            <View style={[styles.datoObs, { marginTop: 10 }]}>
                <Text style={styles.labelName2Obs}>Observaciones:</Text>
                <Text style={styles.labelValueObs}>{info.observaciones || '--'}</Text>
            </View>

            {(info.terminos_condiciones && info.terminos_condiciones !== '') &&
                <View style={[styles.datoObs, { marginTop: 10 }]}>
                    <Text style={[styles.labelName2Obs, { width: 200 }]}>Términos y condiciones:</Text>
                    <Text style={styles.labelValueObs}>{info.terminos_condiciones || '--'}</Text>
                </View>
            }

        </>
    )
}

const Firmas = ({ info }) => {

    return (
        <View style={styles.firmas}>
            <Text style={styles.firmantes}>Firma y Sello Cliente (Directo)</Text>
            <Text style={styles.firmantes}>Central de Medios</Text>
            <Text style={styles.firmantes}>Ejecutivo Comercial</Text>
        </View>
    )
}